// extracted by mini-css-extract-plugin
export default {"saveBtn":"saveBtn_saveBtn__89VEd"};